// --------------------------------------------
// Mary's Meals Payment Charge Calculator
// version 1.0, March 8th, 2016
// Handcrafted by Dr. David Banner
// --------------------------------------------

(function($, WS, ob_set) {
	'use strict';

	// require WS utility namespace
	if (typeof WS === 'undefined') {
		throw new Error('Whitespace utility namespace does not exist');
	}

	/**
	 */
	var paymentCC = function(settings) {
		var my;

		my = {
			enable: function() {
				settings = ob_set(settings || {}, paymentCC.defaults);
				my.init(settings.selectors);
			},

			init: function(selectors) {
				// setup initial display
				var totals, val = $(selectors.input).val();

				if (typeof val === 'undefined') {
					return;
				}

				val = val.replace(window.GLOBALS.decimal_seperator,'D').replace(window.GLOBALS.thousands_seperator,'T');
				val = val.replace('D','.').replace('T','');

				totals = my.getTotals(val);
				my.updateDisplay(selectors, totals);

				// setup any events
				my.events(selectors);
			},

			events: function(selectors) {
				// watch for changes on the INPUT
				$(selectors.input).on('keyup', function(event) {
					var totals, val = $(this).val();

					if (typeof val === 'undefined') {
						return;
					}

					val = val.replace(window.GLOBALS.decimal_seperator,'D').replace(window.GLOBALS.thousands_seperator,'T');
					val = val.replace('D','.').replace('T','');

					totals = my.getTotals(val);
					my.updateDisplay(selectors, totals);
				});
			},

			getTotals: function(amount) {
				var donation = 0, flat = 0, percent = 0, vat = 0, charge = 0, total = 0;

				flat     = parseFloat(window.GLOBALS.gateway_charge_flat_fee) || 0;
				percent  = parseFloat(window.GLOBALS.gateway_charge_percent) || 0;
				vat      = parseFloat(window.GLOBALS.gateway_charge_vat) || 0;
				donation = parseFloat(amount);

				if (amount > 0) {
					// base total
					charge = ((donation * percent) / 100) + flat;

					// vat?
					charge = charge + (charge * vat) / 100;

					// round to 2dp or return 0 if charge was NaN
					charge = Math.round(charge * 100) / 100 || 0;
				}

				// grand total
				total = donation + charge;

				return {
					'charge': $.getFormattedCurrency(charge,{region: window.GLOBALS.country_code, suppressCurrencySymbol: true}),
					'total':  $.getFormattedCurrency(total,{region: window.GLOBALS.country_code, suppressCurrencySymbol: true})
				};
			},

			updateDisplay: function(selectors, totals) {
				$(selectors.display).text(totals.charge);
				$(selectors.total).text(totals.total);
			}
		}

		my.enable(settings);
	};

	/**
	 * The default WS.paymentCC settings
	 * @typedef WS.paymentCC.defaults
	 * @property {object} selectors - Default selector settings.
	 */
	paymentCC.defaults = {};

	$.WS.createModule('paymentCC', paymentCC);
	window.WS.paymentCC = paymentCC;
}(
	window.jQuery,
	window.WS,
	window.ob_set
));
